export const trackRateType = type => {
    const values = [
        { name: 'free', value: 'Free' },
        { name: 'fixed', value: 'Fixed' },
        { name: 'open', value: 'Donation' }
    ];
    return values.find(it => it.name === type).value;
};

export const allowExitingEventCreation = ({ organization, organizationInfos }) =>
    // if an org doesn't have any event (!organizationInfos?.has_event), it doesn't make sense for the user
    // to leave the event creation form. However, if it has an event but didn't finish the onboarding, we still
    // want to keep the user in the form. The logic is kept here to avoid duplicating it all over the place in the UI.
    !!(organization?.onboarding_date && organizationInfos?.has_event);

/**
 * Emoji aren't supported, we should remove them.
 * - 3 bytes emojis break the ticket pdf generation
 * - 4 bytes emojis are not understood by the menhir db and become "????" characters
 */
export function removeEmoji(text) {
    const emojiRegex = /\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
    return text.replace(emojiRegex, '');
}
